import { useCallback, useRef, useState } from 'react';

interface DropZoneProps {
  accept?: string;
  onFile: (file: File) => void;
  disabled?: boolean;
}

const ACCEPT_DEFAULT = 'image/jpeg,image/png,application/pdf';

export function DropZone({ accept = ACCEPT_DEFAULT, onFile, disabled }: DropZoneProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);

  const handleFiles = useCallback(
    (files: FileList | null) => {
      if (!files || files.length === 0) return;
      const file = files[0]!;
      onFile(file);
    },
    [onFile],
  );

  return (
    <div
      onDragOver={(e) => {
        e.preventDefault();
        if (!disabled) setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        if (!disabled) handleFiles(e.dataTransfer.files);
      }}
      onClick={() => !disabled && inputRef.current?.click()}
      className={[
        'group relative flex flex-col items-center justify-center gap-3 px-6 py-12 rounded-xl border-2 border-dashed transition cursor-pointer text-center',
        over ? 'border-accent bg-accent-soft/40' : 'border-line bg-card hover:border-fg-2',
        disabled ? 'opacity-50 cursor-not-allowed' : '',
      ].join(' ')}
    >
      <div className="w-12 h-12 rounded-full bg-bg-2 flex items-center justify-center text-2xl">
        📷
      </div>
      <div>
        <div className="text-base font-medium">Trage poza PV-ului aici</div>
        <div className="text-xs text-muted mt-1">sau apasă pentru a alege un fișier · JPG, PNG sau PDF (max 10 MB)</div>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        disabled={disabled}
        onChange={(e) => handleFiles(e.target.files)}
        className="hidden"
      />
    </div>
  );
}
